import { Dog } from './dog';

export class TrainedDog extends Dog {
    id = 0;
    trainingLevel: string;
    price: number;
    deposit: number;
    guarantee: string;
}
